import { render, staticRenderFns } from "./Wldw.vue?vue&type=template&id=6622d2ba&scoped=true&"
import script from "./Wldw.vue?vue&type=script&lang=js&"
export * from "./Wldw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622d2ba",
  null
  
)

export default component.exports